var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"header"},[_c('div',{staticClass:"logo"},[_vm._v("江苏政务服务")]),_c('div',{staticClass:"header-right"},[_c('p',{on:{"click":_vm.logOut}},[_vm._v("退出登录")])])]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('img',{attrs:{"src":require("@/assets/img/banner2.png"),"alt":""}})])
}]

export { render, staticRenderFns }